import { palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiTable = {
  styleOverrides: {
    root: {
      'tr:last-of-type td': {
        borderBottom: 'none'
      }
    }
  },
  variants: [{
    props: {
      type: 'fullWidth'
    },
    style: {
      minWidth: '1258px'
    }
  }, {
    props: {
      type: 'compactMobile'
    },
    style: {
      minWidth: '1280px',
      [breakpointsFunc.breakpoints.down('md')]: {
        minWidth: 'initial',
        '& tr': {
          display: 'flex',
          flexDirection: 'column',
          padding: '18px 24px'
        },
        '& tr + tr': {
          borderTop: "1px solid ".concat(palette.shades[300])
        },
        '& td': {
          padding: '0',
          minHeight: '0',
          border: 'none',
          textAlign: 'left'
        },
        '& td:last-of-type, & td:first-of-type': {
          paddingLeft: '0',
          paddingRight: '0'
        },
        '& td + td': {
          paddingTop: '10px'
        }
      }
    }
  }]
};
export default MuiTable;